/**
 * Typed domain errors. The API maps these to HTTP status codes in its exception
 * filter; nothing else in the system should throw bare strings or `Error`.
 */
export class DomainError extends Error {
    constructor(message) {
        super(message);
        this.name = new.target.name;
    }
}
export class InvalidCurrencyError extends DomainError {
    currency;
    code = 'INVALID_CURRENCY';
    constructor(currency) {
        super(`"${currency}" is not a valid ISO 4217 currency code (expected three letters, e.g. EUR)`);
        this.currency = currency;
    }
}
export class InvalidAmountError extends DomainError {
    code = 'INVALID_AMOUNT';
    constructor(message) {
        super(message);
    }
}
export class CurrencyMismatchError extends DomainError {
    left;
    right;
    code = 'CURRENCY_MISMATCH';
    constructor(left, right) {
        super(`Cannot combine amounts in ${left} and ${right} without an explicit conversion`);
        this.left = left;
        this.right = right;
    }
}
export class InvalidRateError extends DomainError {
    code = 'INVALID_RATE';
    constructor(message) {
        super(message);
    }
}
export class InvalidBudgetProfileError extends DomainError {
    code = 'INVALID_BUDGET_PROFILE';
    constructor(message) {
        super(message);
    }
}
export class SplitMismatchError extends DomainError {
    expected;
    actual;
    code = 'SPLIT_MISMATCH';
    constructor(expected, actual) {
        super(`Splits must sum to the entry total: expected ${expected} minor units, got ${actual} (difference ${actual - expected})`);
        this.expected = expected;
        this.actual = actual;
    }
}
export class AllocationError extends DomainError {
    code = 'ALLOCATION_ERROR';
    constructor(message) {
        super(message);
    }
}
//# sourceMappingURL=errors.js.map